import { IdentityService } from './../identity/identity.service';
import { SiteRoleService } from '../identity/site-role.service';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class SiteAdminUserGuard {
  private readonly siteRoleService = inject(SiteRoleService);

  constructor(
    protected readonly identityService: IdentityService,
    protected readonly router: Router,
  ) {}
  public async canActivate() {
    if (!(await this.isSiteAdmin())) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }

  private async isSiteAdmin(): Promise<boolean> {
    if (!this.identityService.hasCurrentIdentity || !this.identityService.isUserVerified) {
      return false;
    }
    return this.identityService.currentIdentity.isAdmin() || (await this.siteRoleService.isAccountAdminAsync());
  }
}
